import React from 'react'

const Credits = ({children}) => {
  return <>
    <li>Foto di <a href="https://unsplash.com/it/@bermixstudio?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Bermix Studio</a> su <a href="https://unsplash.com/it/foto/vAumq21OXhs?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a></li>
    <li><a href="https://www.pexels.com/it-it/foto/donna-che-esamina-computer-portatile-1467277/" target="_blank" rel="noreferrer">Foto di The Lazy Artist Gallery da Pexels</a></li>
  </>
}

export default Credits